<template>
  <main class="row">

    <div v-if="details.ready" class="col-12 col-md-8 offset-md-2 text-center">

      <h4>Datos de envío</h4>

      <div class="buy-delivery-details mt-4 row">

        <!-- Recipient Name -->
        <div class="col-12 col-md-8 pt-2">

          <label for="text-destinatario" class="font-weight-bold">
            Nombre del destinatario
            <sup class="required-tip">*</sup>
          </label>

          <input type="text"
                 id="text-destinatario"
                 class="form-control"
                 @input="changeRecipientName"
                 :value="delivery.recipient.name"
          >

          <small v-if="nextPressed && delivery.recipient.name == ''"
                 class="text-danger font-weight-bold d-block">
            Ingresá el valor de este campo
          </small>

        </div>

        <!-- Recipient Phone -->
        <div class="col-12 col-md-4  pt-2">

          <label for="text-telefono" class="font-weight-bold">
            Teléfono
            <sup class="required-tip">*</sup>
          </label>

          <input
            id="text-telefono"
            maxlength="13"
            @input="changeRecipientPhone"
            class="form-control"
            type="text"
            :value="recipient_phone"
          >

          <small v-if="nextPressed && delivery.recipient.phone == ''" class="text-danger font-weight-bold d-block">
            Ingresá el valor de este campo
          </small>

          <small v-if="nextPressed && errorPhone != ''" class="text-danger font-weight-bold d-block">
            {{ errorPhone }}
          </small>

        </div>

        <!-- Street -->
        <div class="col-8 pt-2">
          <label for="text-calle" class="font-weight-bold">
            Calle
            <sup class="required-tip">*</sup>
          </label>
          <input type="text" id="text-calle" class="form-control" @input="changeStreet" :value="delivery.street">
          <small v-if="nextPressed && delivery.street == ''" class="text-danger font-weight-bold d-block">
            Ingresá el valor de este campo
          </small>
        </div>

        <!-- Number -->
        <div class="col-4 pt-2">
          <label for="text-numero" class="font-weight-bold">
            Número
            <sup class="required-tip">*</sup>
          </label>
          <input type="text" id="text-numero" class="form-control" @input="changeNumber" :value="delivery.number">
          <small v-if="nextPressed && delivery.number == ''" class="text-danger font-weight-bold d-block">
            Ingresá el número
          </small>
        </div>

        <!-- Level -->
        <div class="col-8 col-md-4 pt-2">
          <label for="text-piso" class="font-weight-bold">
            Piso
          </label>
          <input type="text" id="text-piso" class="form-control" @input="changeLevel"  :value="delivery.level">
        </div>

        <!-- Department -->
        <div class="col-4 col-md-4 pt-2">
          <label for="text-departamento" class="font-weight-bold">
            Depto.
          </label>
          <input type="text" id="text-departamento" class="form-control" @input="changeDepartment" :value="delivery.department">
        </div>

        <!-- Zip code -->
        <div class="col-12 col-md-4 pt-2">
          <label for="text-cp" class="font-weight-bold">
            Código Postal
            <sup class="required-tip">*</sup>
          </label>
          <input type="text" id="text-cp" class="form-control" @input="changeZipCode" :value="delivery.zip_code">
          <small v-if="nextPressed && delivery.zip_code == ''" class="text-danger font-weight-bold d-block">
            Ingresá el código postal
          </small>
        </div>

        <!-- Location -->
        <div class="col-12 col-md-6 pt-2">
          <label for="text-city" class="font-weight-bold">
            Ciudad o Localidad
            <sup class="required-tip">*</sup>
          </label>
          <input type="text" id="text-city" class="form-control" @input="changeLocation"  :value="delivery.location">
          <small v-if="nextPressed && delivery.location == ''" class="text-danger font-weight-bold d-block">
            Ingresá el valor de este campo
          </small>
        </div>

        <!-- Province -->
        <div class="col-12 col-md-6 pt-2">
          <label for="text-provincia" class="font-weight-bold">
            Provincia
            <sup class="required-tip">*</sup>
          </label>
          <input type="text" id="text-provincia" class="form-control" @input="changeProvince" :value="delivery.province">
          <small v-if="nextPressed && delivery.province == ''" class="text-danger font-weight-bold d-block">
            Ingresá el valor de este campo
          </small>
        </div>

        <!-- Description -->
        <div class="col-12 py-2">
          <label for="text-comentarios" class="font-weight-bold">
            Comentarios
          </label>
          <input type="text" id="text-comentarios" class="form-control" @input="changeDescription" :value="delivery.description">
        </div>

      </div>

    </div>

    <!-- Previous and next buttons -->
    <div class="buy-buttons col-sm-12">

      <SquaredButton
        @click="$emit('goToQuantity')"
        styleType="link"
        label="Anterior"
      />

      <SquaredButton
        @click="nextTab"
        styleType="primary"
        label="Siguiente"
        :disabled="isFetching"
      />

    </div>

  </main>
</template>

<script>
  import store from '@/store'
  import {filterNumbersOnly, formatPhone} from '@/helpers'

  export default {

    props: {
    },

    data () {
      return {
        recipient_phone: "",
        nextPressed: false,
        errorPhone: ''
      }
    },

    computed: {

      isFetching: () => store.state.isFetching,

      details: () => store.getters['publication/preview'],

      delivery: () => store.state.buy.delivery,
    },

    async mounted () {
      setTimeout(() => {
        this.recipient_phone = formatPhone(this.delivery.recipient.phone);
      }, 500);
    },

    methods: {
      changeStreet (e) {
        store.dispatch('buy/setDeliveryStreet', e.target.value).then(() => {
          this.changeString();
        })
      },
      changeNumber (e) {
        store.dispatch('buy/setDeliveryNumber', e.target.value).then(() => {
          this.changeString();
        })
      },
      changeLevel (e) {
        store.dispatch('buy/setDeliveryLevel', e.target.value).then(() => {
          this.changeString();
        })
      },
      changeDepartment (e) {
        store.dispatch('buy/setDeliveryDepartment', e.target.value).then(() => {
          this.changeString();
        })
      },
      changeZipCode (e) {
        store.dispatch('buy/setDeliveryPostalCode', e.target.value).then(() => {
        })
      },
      changeLocation (e) {
        store.dispatch('buy/setDeliveryLocation', e.target.value).then(() => {
          // this.changeCity();
          this.changeString();
        })
      },
      changeProvince (e) {
        store.dispatch('buy/setDeliveryProvince', e.target.value).then(() => {
          // this.changeCity();
          this.changeString();
        })
      },
      changeDescription (e) {
        store.dispatch('buy/setDeliveryDescription', e.target.value)
      },
      // changeCity () {
      //   const { location, province } = this.delivery;
      //   store.dispatch('buy/setDeliveryCity',`, ${location}, Provincia de ${province}`);
      // },
      changeString () {
        const { street, number, level, department, zip_code, location, province } = this.delivery;
        let deliveryString = `${street} ${number}`;
        if (level) {
          deliveryString += `, Piso ${level}`;
        }
        if (department) {
          deliveryString += `, Departamento ${department}`;
        }
        deliveryString += `, C.P. ${zip_code}, ${location}, Provincia de ${province}`;
        store.dispatch('buy/setDeliveryString', deliveryString);
      },
      changeRecipientName (e) {
        store.dispatch('buy/setDeliveryRecipientName', e.target.value)
      },
      changeRecipientPhone (e) {
        this.errorPhone = ""
        e.target.value = formatPhone(e.target.value)
        this.recipient_phone = formatPhone(e.target.value)
        store.dispatch('buy/setDeliveryRecipientPhone', filterNumbersOnly(e.target.value))
      },
      nextTab () {
        this.nextPressed = true;
        const { delivery } = this;
        const fields = Object.keys(delivery);
        const missingFields = [];
        for (let i = 0; i < fields.length; i++) {
          const field = fields[i];
          if (!delivery[field] && field !== 'level' && field !== 'department') {
            missingFields.push(field);
          }
        }
        if (missingFields.length === 0) {

          store.dispatch('setIsFetching', true)

          store.dispatch('buy/createShipping')
          .then(resp => {
            this.$emit('goToConfirmation');
          })
          .catch(error => {
            if(error.response.data.code == 422 && error.response.data.error.message.errors['recipient.phone']) {
              this.errorPhone = error.response.data.error.message.errors['recipient.phone'][0]
            }
          })
          .finally(
            store.dispatch('setIsFetching', false)
          );

        } else {
          console.log(`Missing fields: ${missingFields.join(', ')}`);
        }
      },
    },
  }
</script>

<style lang="scss">
.buy-delivery-details {
  background-color: #F7F6F6;
  border-radius: 4px;
  padding: 10px;
}


</style>



// WEBPACK FOOTER //
// src/pages/marketplace/tabs/TabDelivery.vue